import React, { Component } from "react";

import print from "../../assets/print.png"
import zoom from "../../assets/zoom.png"
import download from "../../assets/download.png"
import MyInput from "../../components/MyInput";
import Dropdown from "../../components/Dropdown";
import { addstorepost, adduserPost, editUser, getRoles, getStores } from "../../Path/Path";
import { withRouter } from "../../components/withRouter";
import { toast } from "react-toastify"
import Loader from "../../components/Loader";
import { Autocomplete, TextField } from '@mui/material'
import { validateEmail, validatePassword } from "../../helpers/validator";
import BackButton from "../../components/BackButton";
class AddUser extends Component {
    constructor(props) {
        super(props)

        this.state = {
            name: "",
            userName: "",
            email: "",
            password: "",
            status: "",
            role: [],
            selectRole: "",
            storeName: [],
            storeNameList: [],
            dropStore: "",
            dropRole: "",
            data: [],
            allStores: [],
            showStatus: false,
            showRole: false,
            showStoreId: false,
            loading: false,
        }
    }

    async componentDidMount() {
        this.setState({ loading: true })
        const data = await getRoles();
        const store = await getStores();
        const storesName = store.map((elem) => elem.storename)
        const roleName = data.map((elem) => elem.role_name)
        this.setState({ storeNameList: storesName, data: data, role: roleName, allStores: store })
        // const fil = data.find((i) => i._id === this.props.location.state.item.roleId)

        // this.setState({ slectrole: fil?.role_name })
        // this.setState({ storeName: storesName })
        this.setState({ loading: false })
        if (this.props.location.state?.item) {

            const item = this.props.location.state.item
            const multiple_stores = JSON.parse(item?.status)
            this.setState({
                name: item?.name,
                userName: item?.userName,
                email: item?.email || "",
                password: item?.password,
                selectRole: item?.roleId?.role_name,
                storeName: multiple_stores === 1 ? [] : (multiple_stores || []),
            })
        }

    }

    sendHandler = async () => {
        const editMode = this.props.location?.state?.item;

        try {
            const roleId = this.state.data.find(i => i.role_name === this.state.selectRole)
            const storeId = this.state.allStores.find(i => i.storename === this.state.storeName[0])
            const body = {
                "name": this.state.name.trim(),
                "userName": this.state.userName.trim(),
                "email": this.state.email.trim(),
                "password": this.state.password,
                "siteId": storeId?._id,
                "status": JSON.stringify(this.state.storeName),
                "last_login": JSON.stringify(this.state.storeName),
                "roleId": roleId?._id
            }
            if (this.state.name === "" || this.state.name.trim().length < 2) {
                toast.warn("Enter Name and Name must be at least 2 characters")
            }
            else if (this.state.userName === "" || this.state.userName.trim().length < 2) {
                toast.warn("Enter Username and Username must be at least 2 characters")
            }
            else if (validateEmail(this.state.email)) {
                toast.warn(validateEmail(this.state.email))
            }
            else if (!editMode && this.state.password === "") {
                toast.warn("Enter Password")
            }
            else if (!editMode && validatePassword(this.state.password)) {
                toast.warn(validatePassword(this.state.password))
            }
            else if (this.state.selectRole === "") {
                toast.warn("Select Role")
            }
            else if (this.state.storeName?.length === 0) {
                toast.warn("Kindly assign a store to the user")
            }
            else if (this.props.location?.state?.item) {


                await editUser(body, this.props.location.state.item._id)
                this.props.history("/users");
                toast.success("User edit successfully")
            }

            else {
                this.setState({ loading: true })
                const res = await adduserPost(body)
                console.log(res, "resresresresresres")
                this.setState({ loading: false })
                if (res?.success === false) {
                    toast.warn(res?.error)
                    return
                }
                if (res?.error) {
                    toast.warn("Something went wrong")
                } else {
                    toast.success("User added succesfully")
                    this.props.history("/users");
                }
            }

        } catch (error) {
            console.log(error, "eorrtjkfgnekrgrig")
            toast(error?.response?.data?.error || "Something went wrong")
            this.setState({ loading: false })
        }





    }

    render() {

        const { name, userName, email, password, allStores = [] } = this.state
        const editMode = !!this.props.location?.state?.item
        const passwordValidation = !editMode && password.length > 0 ? validatePassword(password) : null
        const emailValidation = !editMode && email.length > 0 ? validateEmail(email) : null
        return (
            <>
                <Loader loading={this.state.loading} />
                <div className="dashboard-main">
                    <div className="dashboard-top">
                        <div style={{ display: "flex", gap: 10 }}>
                            <BackButton />
                            <p className="stock-count" style={{ marginTop: 5 }}>
                                {editMode ? "Edit User" : "Add User"}
                            </p>
                        </div>

                    </div>
                    <div style={{ paddingInline: 20, marginTop: 20, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                        {/* <div> <p className="filter-text">Filters</p></div> */}

                        <TextField
                            sx={{ width: 320 }}
                            defaultValue={this.state.name}
                            value={name}
                            placeholder="Name"
                            size={'small'}
                            inputProps={{ maxLength: 50 }}
                            error={name.trim().length > 0 && name.trim().length < 2}
                            helperText={
                                name.trim().length > 0 && name.trim().length < 2
                                    ? 'Name must be at least 2 characters'
                                    : ''
                            }
                            onChange={(data) => {
                                const value = data.target.value;
                                const normalized = value
                                    .replace(/[^a-zA-Z0-9@\s]/g, '')
                                    .replace(/\s{2,}/g, ' ')
                                    .replace(/^\s+/, '');

                                this.setState({ name: normalized });
                            }}
                            id="outlined-basic" label="Name" variant="outlined" />
                        <TextField
                            sx={{ width: 320 }}
                            defaultValue={this.state.userName}
                            value={userName}
                            placeholder="User Name"
                            size={'small'}
                            inputProps={{ maxLength: 50 }}
                            error={userName.trim().length > 0 && userName.trim().length < 2}
                            helperText={
                                userName.trim().length > 0 && userName.trim().length < 2
                                    ? 'Username must be at least 2 characters'
                                    : ''
                            }
                            onChange={(data) => {
                                // Convert to lowercase and filter allowed characters only
                                const value = data.target.value
                                    .toLowerCase()
                                    .replace(/[^a-z0-9@\-_! ]/g, '')
                                    .replace(/\s{2,}/g, ' ')
                                    .replace(/^\s+/, '');
                                this.setState({ userName: value });
                            }} 
                            id="outlined-basic" 
                            label="User Name" 
                            variant="outlined" />

                            <TextField
                            sx={{ width: 320 }}
                            defaultValue={this.state.email}
                            value={email}
                            placeholder="Email"
                            size={'small'}
                            inputProps={{ maxLength: 50, autoComplete: 'off' }}
                            onChange={(data) => {
                                // Convert to lowercase and allow only valid email characters
                                const value = data.target.value
                                    
                                    .replace(/[^a-z0-9@.\-_+]/g, '');
                                this.setState({ email: value });
                            }} 
                            error={Boolean(emailValidation)}
                                helperText={
                                    emailValidation || ''
                                }
                            id="outlined-basic" 
                            label="Email" 
                            variant="outlined" 
                            autoComplete="off" />
                        {
                            !editMode &&
                            <TextField
                                sx={{ width: 320 }}
                                defaultValue={this.state.password}
                                value={password}
                                placeholder="Min 6 chars, 1 letter, 1 number, 1 special char"
                                size={'small'}
                                error={Boolean(passwordValidation)}
                                helperText={
                                    passwordValidation || ''
                                }
                                type="password"
                                inputProps={{ autoComplete: 'new-password' }}
                                onChange={(data) => this.setState({ password: data.target.value })} 
                                id="outlined-basic" 
                                label="Password" 
                                variant="outlined"
                                autoComplete="new-password"
                            />
                        }

                    </div>

                    <div style={{ paddingInline: 20, marginTop: 15, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            size={'small'}
                            value={this.state.selectRole}
                            options={this.state.data?.map((item => item?.role_name)).reduce((noDupArr, entry) => {
                                if (noDupArr?.includes(entry)) {
                                    return noDupArr;
                                } else {
                                    return [...noDupArr, entry];
                                }
                            }, [])?.filter((item => item !== null && item !== undefined))}
                            onChange={(e, v) => this.setState({ selectRole: v === null || v === undefined ? '' : v })}
                            sx={{ width: 320 }}
                            renderInput={(params) => <TextField
                                {...params} label="Roles" />}
                        />
                        <Autocomplete
                            multiple={true}
                            disablePortal
                            disableCloseOnSelect={true}
                            id="combo-box-demo"
                            size={'small'}
                            value={this.state?.storeName || null}
                            getOptionLabel={(option) => option ? option : this.state?.storeName}
                            options={this.state.allStores?.map((item => item?.Name)).reduce((noDupArr, entry) => {
                                if (noDupArr?.includes(entry)) {
                                    return noDupArr;
                                } else {
                                    return [...noDupArr, entry];
                                }
                            }, [])?.filter((item => item !== null && item !== undefined))}
                            onChange={(e, v) => this.setState({ storeName: v === null || v === undefined ? '' : v })}
                            sx={{ width: 320 }}
                            renderInput={(params) => <TextField
                                {...params} label="Stores" />}
                        />

                    </div>
                    <div style={{ paddingLeft: 20, marginTop: 20, marginBottom: 20 }} >
                        <button className="run-btn" onClick={() => this.sendHandler()}> <p className="run-text"> {editMode ? "Edit User" : "Add User"}</p></button>
                    </div>
                </div>

            </>
        )
    }
}

export default withRouter(AddUser);